<div class="flex flex-col gap-2">
  <ng-container
    [ngTemplateOutlet]="Contact"
    [ngTemplateOutletContext]="{ contacts: emails, primaryContact: primaryEmail }"
  >
  </ng-container>

  <ng-container
    [ngTemplateOutlet]="Contact"
    [ngTemplateOutletContext]="{ contacts: numbers, primaryContact: primaryPhoneNumber }"
  >
  </ng-container>

  @if (linkedInDisplayUrl) {
    <div class="contact-info">
      <a target="_blank" rel="noopener noreferrer" [matTooltip]="linkedInDisplayUrl" [href]="linkedInDisplayUrl">
        <app-pill class="w-56" color="primary">{{ linkedInDisplayUrl | displayUrl }}</app-pill>
      </a>
      @if (linkedInOverflowUrls.length) {
        <div class="ellipse-box hover">
          <span>...</span>
          <div class="drop-down">
            @for (url of linkedInOverflowUrls; track url) {
              <div class="drop-down-item flex">
                <a target="_blank" rel="noopener noreferrer" [matTooltip]="url" [href]="url">
                  <app-pill class="w-56" color="primary">{{ url | displayUrl }}</app-pill>
                </a>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-template #Contact let-contacts="contacts" let-primaryContact="primaryContact">
  <div class="contact-info">
    @if (primaryContact) {
      <app-shared-contact-info-pill
        [contact]="primaryContact.value"
        [isInvalid]="primaryContact.isInvalid"
      ></app-shared-contact-info-pill>
    }
    @if (!primaryContact && contacts?.length) {
      <app-shared-contact-info-pill
        [contact]="contacts[0].value"
        [isInvalid]="contacts[0].isInvalid"
        [label]="contacts[0].label"
      >
      </app-shared-contact-info-pill>
      @if (contacts.length > 1) {
        <div class="ellipse-box hover">
          <span>...</span>
          <div class="drop-down">
            @for (contact of contacts.slice(1); track contact) {
              <div class="drop-down-item flex">
                <app-shared-contact-info-pill [contact]="contact.value" [isInvalid]="contact.isInvalid">
                </app-shared-contact-info-pill>
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</ng-template>
